import { makeAutoObservable } from "mobx";
import { showErrorToast, showLoadingToast, showSuccessToast } from "../components/toasts";
import RoleService from "../service/RoleService";
import { IUsers } from "../models/IUsers";

export default class RoleManagement {
  selectedUser: IUsers = {} as IUsers;

  constructor() {
    makeAutoObservable(this);
  }


  async getUserData() {
    const fetchUser = await RoleService.fetchUser();
    return fetchUser?.data;
    // return statistics.data;
  }

  async postUserData(data: any) {
    try {
      showLoadingToast("Adding user...")
      const rest = await RoleService.registerUser(data);
      showSuccessToast("User Added Successfully!")
      return rest.data.data
    } catch (error) {
      showErrorToast("Something went wrong!")
      console.log(error)
    }
  }

  async deleteAdminUser(id: string) {
    try {
      const rest = await RoleService.deleteAdmin(id);
      showSuccessToast("User Deleted Successfully!")
      return rest.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateAdminUser(id: string, data: any) {
    try {
      const rest = await RoleService.updateAdmin(id, data);
      showSuccessToast("User Updated Successfully!")
      return rest.data
    } catch (error) {
      console.log(error)
    }
  }

  async fetchSingleUserById(id: any) {
    try {
      const fetchUser = await RoleService
        .fetchSingleUser(id);
      return fetchUser?.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateUserPassword(id: string, data: any) {
    try {
      const rest = await RoleService.updatePassword(id, data);
      showSuccessToast("Password Updated Successfully!")
      return rest.data
    } catch (error: any) {
      console.log(error?.response?.data?.error.message)
      showErrorToast(error?.response?.data?.error?.message || error?.response?.data?.error)
    }
  }

  async updateUserStatus(id: string, data: any) {
    try {
      const rest = await RoleService.updateStatus(id, data);
      showSuccessToast("Updated User Status Successfully!")
      return rest.data
    } catch (error: any) {
      
      showErrorToast(error?.response?.data?.error || error?.response?.data?.error.message)
    }
  }

}